import React, { useEffect, useState } from "react";

const CONTACT_EMAIL = "contact@thefilimonovs.info";

const T = {
  en: {
    badge: "Site update in progress",
    title: "Filimonov Family",
    subtitle: "Family Tree",
    message:
      "We're working on a new version of this page. The family tree will be back online shortly.",
    contactLabel: "Contact",
    langName: "EN",
  },
  ru: {
    badge: "Сайт обновляется",
    title: "Род Филимоновых",
    subtitle: "Генеалогическое древо",
    message:
      "Мы готовим новую версию страницы. Генеалогическое древо скоро снова будет доступно.",
    contactLabel: "Контакты",
    langName: "RU",
  },
};

export default function Placeholder() {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem("filimonov_lang");
      if (saved === "en" || saved === "ru") return saved;
    } catch (e) {}
    return (navigator.language || "").toLowerCase().startsWith("ru") ? "ru" : "en";
  });

  const [dark, setDark] = useState(() => {
    try {
      const saved = localStorage.getItem("filimonov_dark");
      if (saved === "1") return true;
      if (saved === "0") return false;
    } catch (e) {}
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    try {
      localStorage.setItem("filimonov_lang", lang);
    } catch (e) {}
  }, [lang]);

  useEffect(() => {
    try {
      localStorage.setItem("filimonov_dark", dark ? "1" : "0");
    } catch (e) {}
  }, [dark]);

  useEffect(() => {
    document.title =
      lang === "ru" ? "Род Филимоновых · Сайт обновляется" : "Filimonov Family · Site update in progress";
  }, [lang]);

  const t = T[lang];

  const colors = dark
    ? {
        bg: "#12203a",
        card: "#182a4a",
        text: "#f2ead9",
        subtext: "#b9c3d6",
        accent: "#c9974f",
        border: "rgba(255,255,255,0.12)",
        toggleBg: "rgba(255,255,255,0.08)",
      }
    : {
        bg: "#f5f0e6",
        card: "#ffffff",
        text: "#1a2233",
        subtext: "#5c6470",
        accent: "#1a3d6e",
        border: "rgba(0,0,0,0.08)",
        toggleBg: "rgba(0,0,0,0.05)",
      };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: colors.bg,
        color: colors.text,
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        transition: "background 0.2s ease, color 0.2s ease",
        padding: 24,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          display: "flex",
          gap: 8,
        }}
      >
        <button
          onClick={() => setLang(lang === "en" ? "ru" : "en")}
          style={toggleButtonStyle(colors)}
        >
          {lang === "en" ? "RU" : "EN"}
        </button>
        <button
          onClick={() => setDark(!dark)}
          style={toggleButtonStyle(colors)}
          aria-label="Toggle dark mode"
        >
          {dark ? "☀️" : "🌙"}
        </button>
      </div>

      <div
        style={{
          maxWidth: 480,
          width: "100%",
          background: colors.card,
          border: `1px solid ${colors.border}`,
          borderRadius: 16,
          padding: "40px 32px",
          textAlign: "center",
          boxShadow: dark
            ? "0 20px 60px rgba(0,0,0,0.4)"
            : "0 20px 60px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            margin: "0 auto 20px",
            borderRadius: "50%",
            background: colors.accent,
            color: dark ? "#12203a" : "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Georgia, serif",
            fontSize: 26,
            fontWeight: "bold",
          }}
        >
          Ф
        </div>

        <div
          style={{
            display: "inline-block",
            fontSize: 12,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: colors.accent,
            border: `1px solid ${colors.accent}`,
            borderRadius: 999,
            padding: "4px 12px",
            marginBottom: 16,
          }}
        >
          {t.badge}
        </div>

        <h1
          style={{
            fontFamily: "Georgia, serif",
            fontSize: 28,
            margin: "0 0 4px",
          }}
        >
          {t.title}
        </h1>
        <div style={{ color: colors.subtext, marginBottom: 20, fontSize: 15 }}>
          {t.subtitle}
        </div>

        <p
          style={{
            fontSize: 15,
            lineHeight: 1.6,
            color: colors.subtext,
            margin: "0 0 28px",
          }}
        >
          {t.message}
        </p>

        <div
          style={{
            fontSize: 13,
            color: colors.subtext,
            borderTop: `1px solid ${colors.border}`,
            paddingTop: 18,
          }}
        >
          {t.contactLabel}:{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: colors.accent }}>
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </div>
  );
}

function toggleButtonStyle(colors) {
  return {
    background: colors.toggleBg,
    color: colors.text,
    border: `1px solid ${colors.border}`,
    borderRadius: 8,
    padding: "6px 10px",
    fontSize: 13,
    cursor: "pointer",
  };
}
